import { Component, Input, OnInit } from '@angular/core';

/**
 * Componente que muestra una etiqueta de estado con texto y color configurables.
 */
@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {
  @Input() text: string = '';
  @Input() color: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
